<template>
  <div class="yqgkcCon wlsecov">
    <div class="yiqiList" @click.stop="wltcshow($event)">
        <vue-seamless-scroll :data="survData" :class-option="optionLeft">
              <div class="qyListCov"  v-for="(item,index) in survData" :key="index" :data-item="JSON.stringify(item)">
                <img :src="urlimg+item.bsIcon" alt="" class="qyicon">
                <div class="qyrit">
                    <span class="qyritName">{{item.name}}</span>
                    <span class="qiritdanw">{{item.value}} <span> {{item.unit}}</span></span>
                </div>
              </div>
        </vue-seamless-scroll>
    </div>
    <div class="listTit" @click="jkshow">视频监控</div>
    <div style="width: 440px;height:220px;overflow:hidden;">
      <div id="ezuikit-player" v-if="cameraValue.deviceIotUrl"></div>
      <video
        ref="video"
        class="video-js vjs-default-skin"
        style="width:100%;"
        height="220"
        @play="onPlay"
        @pause="onPause"
        controls
        autoplay
        v-else
      >
        <source :src="cameraValue.deviceUrl" />
      </video>
    </div>
    <el-dialog
      width="100%"
      top="0px"
      :visible.sync="kjdialogTableVisible"
      :modal-append-to-body="false"
    >
      <div class="jklistchanye" style="height: 1000px;">
          <img
            src="@/assets/images/guanbi.png"
            class="guanbiann"
            @click="qcguanbi"
            alt=""
          />
          <div class="tz_cov_topchanye">
            <span class="tz_cov_top_tit">监控列表</span>
          </div>
          <div class="jkListPl">
            <div class="tczpms_list" v-for="(item,index) in VideoList.records" :key="index">
              <div class="tczpms_list_top" >
                <span class="tczpms_list_top_lf">{{ item.deployRemark }}</span>
              </div>
              <img
                  src="@/assets/images/zdjkimg.png"
                  class="jczimg"
                  @click="sxtshow(item)"
                  alt=""
                  v-if="jkShowstring==true"
                />
                <div v-else :id="item.deployCode" class="jczimg"></div>
            </div>
            <!-- <div class="jkOver">
              <img src="@/assets/images/jko1guang.png" alt="" class="jko1guang" @click="jkclick">
            </div> -->
          </div>
          <el-pagination
           @current-change="handleCurrentChange"
           v-if="VideoList.total>12"
            background
            layout="prev, pager, next"
            style="margin-top:6px;"
            :total="VideoList.total">
          </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      width="100%"
      top="0px"
      :visible.sync="sxtshowdialogTableVisible"
      :modal-append-to-body="false"
      v-if="sxtshowdialogTableVisible"
    >
      <div 
        class="tz_cov_zaip"
      >
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi1"
          alt=""
        />
        <div class="tz_cov_topchanye" style="margin-bottom:0px;">
          <span class="tz_cov_top_tit">{{ showSeployDes }}</span>
        </div>
        <div class="sxtshowcov" style="width:100%;">
          <div :id="itemdeployCode" v-if="deviceIotUrl"></div>
          <video
            ref="video"
            class="video-js vjs-default-skin"
            style="width:100%;height:950px"
            height="950"
            @play="onPlay"
            @pause="onPause"
            controls
            autoplay
            v-else
          >
            <source :src="deviceUrl" />
          </video>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="100%"
      top="0px"
      :visible.sync="sxtqjshowdialogTableVisible"
      :modal-append-to-body="false"
      v-if="sxtqjshowdialogTableVisible"
    >
      <div 
        class="tz_cov_zaip"
      >
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi1"
          alt=""
        />
        <div class="tz_cov_topchanye" style="margin-bottom:0px;">
          <span class="tz_cov_top_tit">{{ showSeployDes }}</span>
        </div>
        <div class="sxtshowcov" style="width:100%;overflow:hidden;">
          <div :id="itemdeployCode" style="width:80%;float:left;"></div>
          <div class="jkczCov">
              <div class="jkczCov_sxzy">
                  <div class="jkczCov_Topsxzy" @click="cameraStartStart('0')"><i class="el-icon-arrow-up"></i></div>
                  <div class="jkczCov_Btmsxzy" @click="cameraStartStart('1')"><i class="el-icon-arrow-down"></i></div>
                  <div class="jkczCov_Lfsxzy"  @click="cameraStartStart('2')"><i class="el-icon-arrow-left"></i></div>
                  <div class="jkczCov_Rtsxzy"  @click="cameraStartStart('3')"><i class="el-icon-arrow-right"></i></div>
              </div>
              <div class="jkczCov_daxiao">
                  <img src="@/assets/images/jkenlarge.png" alt="" @click="cameraStartStart('8')" class="daxiaoLf">
                  <img src="@/assets/images/jkzoomout.png" alt="" @click="cameraStartStart('9')" class="daxiaoRt">
              </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 空气弹窗 -->
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="qczddialogTableVisible"
      :modal-append-to-body="false"
	    :destroy-on-close="true"
      v-if="qczddialogTableVisible"
    >
      <div class="tzqx_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">气象环境监测</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="10">
            <div class="grid-content bg-purple ycboxlt4">
				<span class="tcxitit" >实时监测信息</span>
                <div class="qxsjssjcTc">
					<div class="qxsjssjc_leftTc">
						<div class="qxsjssjc_left_list shouxing" v-if="fengx" @click="cyzxshow(fengx)">
							<span class="qxsjssjc_left_list_show" v-if="348.76 < fengx.value || fengx.value < 11.25">北风</span>
							<span class="qxsjssjc_left_list_show" v-else-if="11.26 < fengx.value < 33.75">北东北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="33.76 < fengx.value < 56.25">东北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="56.26 < fengx.value < 78.75">东东北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="78.76 < fengx.value < 101.25">东</span>
							<span class="qxsjssjc_left_list_show" v-else-if="101.26 < fengx.value < 123.75">东东南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="123.76 < fengx.value < 146.25">东南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="146.26 < fengx.value < 168.75">南东南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="168.76 < fengx.value < 191.25">南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="191.26 < fengx.value < 213.75">南西南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="213.76 < fengx.value < 236.25">西南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="236.26 < fengx.value < 258.75">西西南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="258.76 < fengx.value < 281.25">西</span>
							<span class="qxsjssjc_left_list_show" v-else-if="281.26 < fengx.value < 303.75">西西北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="303.76 < fengx.value < 326.25">西北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="337.5 < fengx.value < 348.75">北西北</span>
							<span class="qxsjssjc_left_list_show" v-else>静风</span>
							<div class="qxsjssjc_left_list_tit">
								{{fengx.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="zhaodu" @click="cyzxshow(zhaodu)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum11" from="0" :to="zhaodu.value" :key="zhaodu.value" duration="3000"></animate-number>
							{{zhaodu.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{zhaodu.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="yuliang" @click="cyzxshow(yuliang)" style="margin-top:1.5vw;">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum13" from="0" :to="yuliang.value" :key="yuliang.value" duration="3000"></animate-number>
							{{yuliang.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{yuliang.name}}
							</div>
						</div>
					</div>
					
					<div class="qxjcimg2">
						<img src="@/assets/images/tcdiqx.png" class="tcyqimg"  alt="">
						<img src="@/assets/images/tcdidizuo.png" class="tcdzimg" alt="">
					</div>
					<div class="qxsjssjc_leftTc2">
						<div class="qxsjssjc_left_list shouxing" v-if="fengs" @click="cyzxshow(fengs)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum14" from="0" :to="fengs.value" :key="fengs.value" duration="3000"></animate-number>
								{{fengs.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{fengs.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="dqwd" @click="cyzxshow(dqwd)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum15" from="0" :to="dqwd.value" :key="dqwd.value" duration="3000"></animate-number>
								{{dqwd.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{dqwd.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="dqsd" @click="cyzxshow(dqsd)" >
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum16" from="0" :to="dqsd.value" :key="dqsd.value" duration="3000"></animate-number>
								{{dqsd.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{dqsd.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="dqyl" @click="cyzxshow(dqyl)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum17" from="0" :to="dqyl.value" :key="dqyl.value" duration="3000"></animate-number>
								{{dqyl.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{dqyl.name}}
							</div>
						</div>
					</div>
				</div>
            </div>
          </el-col>
          <el-col :span="14">
            <span class="tcxitit">气象监测历史记录</span>
			<div class="bianqianlist">
				<div :class="time==1?'xiaoshiHover':'xiaoshi'" @click="timeqieh('xiao')">小时</div>
				<div :class="time==2?'xiaoshiHover':'xiaoshi'" @click="timeqieh('ri')">日均</div>
				<div :class="time==3?'xiaoshiHover':'xiaoshi'" @click="timeqieh('yue')">月均</div>
				<el-date-picker
					v-model="value1"
					class="custom-date-picker"
					type="date"
					size="small"
					@blur="timetrpicker"
					style="float:left;margin-left:10px;"
					placeholder="选择日期">
				</el-date-picker>
				<div class="xiaoshiHover" @click="tanchuangshuj" >查询</div>
				<div class="zsfsList">
					展示方式：
					<el-radio-group v-model="radio1" @input="numtab" size="small" fill="#04A66F" >
						<el-radio-button label="折线"></el-radio-button>
						<el-radio-button label="表格"></el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<div ref="columnzxEchart" v-if="tabnum==true" style="width: 100%; height: 480px;"></div>
			<el-table
			    v-else
				:data="formListVlaue"
				height="480"
				border
				style="width: 100%;">
				<el-table-column
				prop="date"
				label="时间"
				width="360">
				</el-table-column>
				<el-table-column
				prop="name"
				:label="'数值单位：' + unitValue">
				</el-table-column>
			</el-table>
			<div class="loader" v-if="lodshow==true">
				<div class="loader-inner ball-grid-pulse">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<span class="lodingspan">加载中......</span>
			</div>

          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 土壤弹窗 -->
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="trzddialogTableVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      v-if="trzddialogTableVisible"
    >
      <div class="tztr_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">土壤环境监测</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="10">
            <div class="grid-content bg-purple ycboxlt4">
              <span class="tcxitit" >实时监测信息</span>
              <div class="qxsjssjcTc" @click.stop="trzxshow($event)">
                <div class="qxsjssjc_left" style="margin-top:20px;">
                  <el-col :span="24" class="tcgd2"  style="padding: 0px" v-for="(item, index) in airDataListHome1" :key="index" :data-item="JSON.stringify(item)">
                      <div class="jcsjtclist"  style="overflow: hidden" >
                        <el-row >
                          <el-col :span="10">
                            <img :src="urlimg+item.bsIcon" alt="" class="jcsjicon1" />
                          </el-col>
                          <el-col :span="14">
                            <span class="jcsjicon1_tit">{{ item.name }}   </span>
                            <button type="button" @click="startAnimate()" style="display: none"></button>
                            <span class="jcsjicon1_num" v-if="item.value == '0' || item.value == '0.0'|| item.value == undefined" >
                              <span>0</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                            <span class="jcsjicon1_num" v-else>
                              <animate-number style="display:none;" ref="myNum1" from="0" :to="item.value" :key="item.value" duration="3000" ></animate-number>
                              <span >{{item.value}}</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                          </el-col>
                        </el-row>
                      </div>
                  </el-col>
                </div>
                
                <div class="qxjcimg2">
                  <img src="@/assets/images/tcditr.png" class="tcyqimg"  alt="">
                  <img src="@/assets/images/tcdidizuo.png" class="tcdzimg" alt="">
                </div>
                <div class="qxsjssjc_right" style="margin-top:20px;">
                  <el-col :span="24" class="tcgd2"  style="padding: 0px" v-for="(item, index) in airDataListHome2" :key="index" :data-item="JSON.stringify(item)">
                      <div class="jcsjtclist"  style="overflow: hidden" >
                        <el-row >
                          <el-col :span="10">
                            <img :src="urlimg+item.bsIcon" alt="" class="jcsjicon1" />
                          </el-col>
                          <el-col :span="14">
                            <span class="jcsjicon1_tit">{{ item.name }}   </span>
                            <button type="button" @click="startAnimate()" style="display: none"></button>
                            <span class="jcsjicon1_num" v-if="item.value == '0' || item.value == '0.0'|| item.value == undefined" >
                              <span>0</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                            <span class="jcsjicon1_num" v-else>
                              <animate-number style="display:none;" ref="myNum1" from="0" :to="item.value" :key="item.value" duration="3000" ></animate-number>
                              <span >{{item.value}}</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                          </el-col>
                        </el-row>
                      </div>
                  </el-col>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <span class="tcxitit">土壤监测历史记录</span>
              <div class="bianqianlist">
                <div :class="time==1?'xiaoshiHover':'xiaoshi'" @click="timeqieh('xiao')">小时</div>
                <div :class="time==2?'xiaoshiHover':'xiaoshi'" @click="timeqieh('ri')">日均</div>
                <div :class="time==3?'xiaoshiHover':'xiaoshi'" @click="timeqieh('yue')">月均</div>
                <el-date-picker
                  v-model="value1"
                  class="custom-date-picker"
                  type="date"
                  size="small"
                  @blur="timetrpicker"
                  style="float:left;margin-left:10px;"
                  placeholder="选择日期">
                </el-date-picker>
                <div class="xiaoshiHover" @click="tanchuangshuj">查询</div>
                <div class="zsfsList">
                  展示方式：
                  <el-radio-group v-model="radio1" @input="numtab" size="small" fill="#04A66F" >
                    <el-radio-button label="折线"></el-radio-button>
                    <el-radio-button label="表格"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div ref="columnTrEchart" v-if="tabnum==true" style="width: 100%; height: 480px;"></div>
              <el-table
                v-else
                :data="formListVlaue"
                height="480"
                border
                style="width: 100%;">
                <el-table-column
                prop="date"
                label="时间"
                width="360">
                </el-table-column>
                <el-table-column
                prop="name"
                :label="'数值单位：' + unitValue">
                </el-table-column>
              </el-table>
              <div class="loader" v-if="lodshow==true">
                <div class="loader-inner ball-grid-pulse">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <span class="lodingspan">加载中......</span>
              </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import EZUIKit from 'ezuikit-js';
import { cameraStart,cameraStop,deviceSummary,getDeviceTransData,deviceInvoke } from'@/api'
export default {
  props:{
    survData:Array,
    cameraValue:Object,
    urlimg:String,
    VideoList:Object,
    auths:String,
  },
  name: "ykgkCov",
  data(){
    return{
      controls:false,
      autoplay:true,
      video:{},
      yiqiListP:[],
      kjdialogTableVisible:false,
      playerList: [],
      sxtshowdialogTableVisible:false,
      sxtqjshowdialogTableVisible:false,
      showSeployDes:'',
      itemdeployCode:'',
      deployId:'',
      jkShowstring:true,
      qczddialogTableVisible: false,
      trzddialogTableVisible: false,
      lodshow:true,
      airDataListHome1:[],
      airDataListHome2:[],
      lodshow:true,
		   tabnum:true,
		   formListVlaue: [],
		   dqwd:'',
		   dqsd:'',
		   dqyl:'',
		   fengs:'',
		   fengx:'',
		   yuliang:'',
		   zhaodu:'',
		   unitValue:'',
       time:1,
		   value1: '',
		   radio1: '折线',
       airDataListHome:[],
      airDataListHome1:[],
      airDataListHome2:[],
      formListVlaue: [],
      deviceUrl:'',
      player:null,
      countdownTime: 60,//关闭监控
      deviceIotUrl:'',
      // video暂停开始
      isPlaying: false,
      status: '未播放',
      pauseTimer: null,
      // video暂停结束
    }
  },
  created(){
  },
  computed: {
    optionLeft() {
      return{
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted() {
    if (this.cameraValue.deviceIotUrl) {
      setTimeout(()=>{
        this.initPlayer()
      },500)
    }else{
      this.player = this.$video(this.$refs.video);
    }
  },
  methods:{
    initPlayer(){
      this.player = new EZUIKit.EZUIKitPlayer({
        id: `ezuikit-player`,
        url: this.cameraValue.deviceIotUrl,
        accessToken: this.cameraValue.ysToken,
        template: "security", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；pc使用;
        audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
        width:450,
        height:220,
        // 关闭监控
        handleSuccess: (rea) => {
            setTimeout(() => {
                this.timer =
                    setInterval(
                        () => {
                            this.countdown(
                                this.player
                            )
                        }, 1000
                    );
            }, 2000)
            if (rea.type=="handleSuccess") {
              setInterval(this.liuliangjc(this.cameraValue.id), 60000);
            }
        },
      })
      // 关闭监控
      setTimeout(() => {
          this.player.closeSound()//关声音
          this.player.eventEmitter.on('fast',(e)=>{
              this.timer = setInterval( () => { 
                  this.countdown(this.player)
              }, 1000); 
          })
          this.player.eventEmitter.on('pause',(e)=>{
              this.countdownTime = 60
          })
      }, 4000)
    },
    // 一分钟后关监控
    countdown(player, index) {
        if (this.countdownTime > 0) {
            this.countdownTime--;
        } else {
            clearInterval(this.timer); // 停止计时器
            if (player.themeId) {
                player && player.pause()
            } else {
                this.pause(player, index)
            }
        }
    },
    // 每隔一分钟调一次接口监测流量
    liuliangjc(deployId){
      deviceInvoke({
        deployId:deployId,
        useType:'view',
        useMark:'live',
        terminal:'bs'
      }).then(res=>{
        console.log("每隔一分钟调一次接口监测流量",res)
      })
    },
    toggleAudio() {
      if (this.isMuted) {
        this.player.unmute();
      } else {
        this.player.mute();
      }
      this.isMuted = !this.isMuted;
    },
    jkclick(){
      this.jkShowstring = !this.jkShowstring
      if (this.jkShowstring==false) {
        setTimeout(()=>{
          this.VideoList.records.map((itm,index) => {
            this.playerList[index] = new EZUIKit.EZUIKitPlayer({
                id: itm.deployCode , // 视频容器ID+ 'L01'
                accessToken: itm.ysToken,
                url: itm.deviceIotUrl,
                template: "security", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
                audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
                autoplay: true,
                width:440,
                height:250,
                // 关闭监控
                handleSuccess: (rea) => {
                    setTimeout(() => {
                        this.timer =
                            setInterval(
                                () => {
                                    this.countdown(
                                        this.playerList[index]
                                    )
                                }, 1000
                            );
                    }, 2000)
                },
            })
          })
        },1500)
      }
      
    },
    cameraStartStart(e){
      this.number = e
      let obj = {
        auths:this.auths,
        cameraId:this.deployId,
        number:this.number
      }
      cameraStart(obj).then(res=>{
          setTimeout(() => {
            this.cameraStartStop()
          }, 500);
      })
    },
    cameraStartStop(){
      let val = {
        auths:this.auths,
        cameraId:this.deployId,
      }
      cameraStop(val).then(res=>{
      })
    },
    handleCurrentChange(currentPage){
      this.$emit('handleCurrentChange',currentPage)
    },
    jkshow() {
      this.kjdialogTableVisible = true;
    },
    qcguanbi() {
      this.kjdialogTableVisible = false;
      this.qczddialogTableVisible = false;
      this.trzddialogTableVisible = false;
    },
    qcguanbi1(){
      this.sxtshowdialogTableVisible = false;
      this.sxtqjshowdialogTableVisible = false;
    },
    sxtshow(e){
      this.deployId = e.id
      this.itemdeployCode = e.deployCode
      this.deviceIotUrl = e.deviceIotUrl
      this.showSeployDes = e.deployRemark
      this.sxtdeploySecondaryType = e.deploySecondaryType
      if (e.deploySecondaryType=='ball') {
        this.sxtqjshowdialogTableVisible = true
        if (this.showSeployDes) {
          setTimeout(() =>{
            this.playerTc = new EZUIKit.EZUIKitPlayer({
              id: e.deployCode, // 视频容器ID
              accessToken: e.ysToken,
              url: e.deviceIotUrl,
              template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
              audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
              autoplay: true,
              width:1440,
              height:950,
              // 关闭监控
                handleSuccess: (rea) => {
                    setTimeout(() => {
                        this.timer =
                            setInterval(
                                () => {
                                    this.countdown(
                                        this.playerTc
                                    )
                                }, 1000
                            );
                    }, 2000)
                },
            })
          }, 300)
        }
      } else {
        if (e.deviceIotUrl) {
          setTimeout(() =>{
            this.playerTc = new EZUIKit.EZUIKitPlayer({
              id: e.deployCode, // 视频容器ID
              accessToken: e.ysToken,
              url: e.deviceIotUrl,
              template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
              audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
              autoplay: true,
              width:1820,
              height:950,
              // 关闭监控
                handleSuccess: (rea) => {
                    setTimeout(() => {
                        this.timer =
                            setInterval(
                                () => {
                                    this.countdown(
                                        this.playerTc
                                    )
                                }, 1000
                            );
                    }, 2000)
                },
            })
          }, 300)
        }else{
          setTimeout(() => {
            this.player = this.$video(this.$refs.video);
            this.deviceUrl = e.deviceUrl
          }, 1300);
        }
      }
      this.sxtshowdialogTableVisible = true;
    },
    // video自动停止
    onPlay() {
      this.isPlaying = true
      this.status = '播放中'
      
      // 清除之前的定时器（如果有）
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer)
      }
      
      // 设置1分钟后暂停的定时器
      this.pauseTimer = setTimeout(() => {
        this.$refs.video.pause()
        this.isPlaying = false
        this.status = '已自动暂停'
      }, 10000) // 60000毫秒 = 1分钟
    },
    onPause() {
      // 如果是自动暂停，不要清除状态
      if (this.status !== '已自动暂停') {
        this.isPlaying = false
        this.status = '已暂停'
      }
      
      // 清除定时器（如果用户手动暂停）
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer)
        this.pauseTimer = null
      }
    },
    // video自动停止结束
    // 硬件数据据接口 
    gardenBelowApi(deployId){
      let pageNo = ''
      let pageSize = ''
      let startTime = ''
      let endTime = ''
      getDeviceTransData(deployId,pageNo,pageSize,startTime,endTime).then(res=>{
           res.result.data.map(val=>{
              if (val.survType=='soil') {
                this.soilDataList = res.result.data
                this.airDataListHome1 = this.soilDataList.slice(0,6)
                this.airDataListHome2 = this.soilDataList.slice(6)
              } else {
                this.airValue = res.result.data
                this.dqwd = this.airValue[0]?this.airValue[0]:'';
                this.dqsd = this.airValue[1]?this.airValue[1]:'';
                this.dqyl = this.airValue[2]?this.airValue[2]:'';
                this.fengs = this.airValue[3]?this.airValue[3]:'';
                this.fengx = this.airValue[4]?this.airValue[4]:'';
                this.yuliang = this.airValue[5]?this.airValue[5]:'';
                this.zhaodu = this.airValue[6]?this.airValue[6]:'';
              }
           })
        })
    },
    wltcshow(e) {
      const lisst = e.target.closest(".qyListCov"); // 定位元素
      if (lisst) { // 是否是滚动组件的某一行/列
        let itemlist  = lisst.dataset.item
        let value = JSON.parse(itemlist)
        this.gardenBelowApi(value.deployId)
        this.deployId = value.deployId
        this.itemValue = value.item
        this.summrayMode = 'dayhours'
        this.deviceSummaryApi()
        let that = this
        if (value.survType=="air") {
          this.qczddialogTableVisible = true;
          that.lodshow = true	
          setTimeout(() => {
            that.echrtCkick()
          }, 1500);
          setTimeout(() => {
            that.lodshow = false	
          }, 2000);
        } else {
          this.trzddialogTableVisible = true;
            that.lodshow = true	
            setTimeout(() => {
              that.echrtTrCkick()
            }, 1500);
            setTimeout(() => {
              that.lodshow = false	
            }, 2000);
        }
      }
    },
    //  气象开始
    numtab(e){
      let that = this
      if (e=='折线') {
        that.tabnum = true
        this.time = 1
        this.summrayMode = 'dayhours'
        this.lodshow = true	
        this.startTime = ''
        this.deviceSummaryApi()
      } else {
        this.tabnum = false
      }
    },
	  timetrpicker(data){
        this.startTime = data.displayValue
    },
    timeqieh(e){
      if (e=='xiao') {
        this.time = 1
        this.lodshow = true	
        this.summrayMode = 'dayhours'
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()
        }, 500);
      } else if(e=='ri') {
        this.time = 2
        this.lodshow = true	
        this.summrayMode = 'monthDays'
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()
        }, 500);
      }else {
        this.time = 3
        this.lodshow = true	
        this.summrayMode = 'yearMonth'
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()
        }, 500);
      }
    },
    tanchuangshuj(){
      this.lodshow = true
      setTimeout(() => {
        this.deviceSummaryApi()
      }, 500);
    },
    startAnimate() {
      if (this.$refs.reNum1) {
        this.$nextTick(() => {
          this.$refs.reNum1.start()
          // this.$refs.reNum2.start()
          this.$refs.reNum3.start()
          this.$refs.reNum4.start()
          this.$refs.reNum5.start()
          this.$refs.reNum6.start()
          this.$refs.reNum7.start()
        })
      }
    },
    cyzxshow(value) {
      this.time = 1
          if (value.deployId) { // 是否是滚动组件的某一行/列
            this.deployId = value.deployId
            this.itemValue = value.item
            this.summrayMode = 'dayhours'
            this.deviceSummaryApi()
          }
      let that = this
        this.qczddialogTableVisible = true;
      that.lodshow = true	
      setTimeout(() => {
        that.echrtCkick()
      }, 1500);
      setTimeout(() => {
        that.lodshow = false	
      }, 2000);
    },
    // 历史数据曲线
    deviceSummaryApi(){
      let obj = {
        deployId:this.deployId,
        startTime:this.startTime,
        survItem:this.itemValue,
        auths:this.auths,
        summrayMode: this.summrayMode,
      }
      deviceSummary(obj).then(res=>{
        let that = this
        this.trListVlaue = res.result
        this.dataListVlaue = res.result.dataList
        this.timeListVlaue = res.result.timeList
        this.formListVlaue = res.result.formList
        this.descriptionValue = res.result.itemInfo.description
        this.unitValue = res.result.itemInfo.unit
        if (res.code==200) {
          setTimeout(() => {
            that.lodshow = false	
            that.$nextTick(() => {
              if (this.qczddialogTableVisible==true) {
                this.echrtCkick();
              } else {
                this.echrtTrCkick();
              }
            })
          }, 1000);
        }
      })
    },
    echrtCkick(){
        // 基于准备好的dom，初始化echarts实例
      
      if (myChartqx != null && myChartqx != "" && myChartqx != undefined) {
        //  已存在则调用 dispose() 方法销毁
        myChartqx.dispose();
      }
      var myChartqx = echarts.init(this.$refs.columnzxEchart);
      // 绘制图表
      let legendData = this.descriptionValue;
      let xAxisData = this.timeListVlaue;
      let seriesData1 = this.dataListVlaue;
      let option;
      option = {
        tooltip: {
        trigger: "axis",
        backgroundColor: "rgba(13, 64, 71, 0.50)",
        borderColor: "rgba(143, 225, 252, 0.60)",
        padding: 8,
        textStyle: {
          color: "#fff",
        },
        },
        grid: {
        left: "1%",
        right: "1%",
        top: "14%",
        bottom: "2%",
        containLabel: true,
        },
        legend: {
        icon: "rect",
        top: "1%",
        itemWidth: 7, // 设置宽度
        itemHeight: 7, // 设置高度
        itemGap: 15, // 设置间距
        textStyle: {
          //图例文字的样式
          color: "#fff",
          fontSize: 14,
        },
        },
        xAxis: {
        boundaryGap: true,
        data: xAxisData,
        axisLine: {
          lineStyle: {
          color: "rgba(117, 168, 202, 0.4)",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#fff",
        },
        },
        yAxis: [
        {
          name: "单位：℃",
          type: "value",
          inverse: false,
          splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(117, 168, 202, 0.3)",
            type: "dashed",
          },
          },
          axisLine: {
          show: false,
          lineStyle: {
            color: "#0A5C95",
          },
          },
          axisLabel: {
          formatter: "{value}",
          textStyle: {
            color: "#89BFE5",
            fontSize: 12,
          },
          },
          nameTextStyle: {
          color: "#89BFE5",
          padding: [0, 0, 0, 15],
          fontSize: 12,
          },
          axisTick: {
          show: false,
          },
        },
        ],
        series: [
        {
          name: legendData,
          type: "line",
          symbol: "circle", //设定为实心点
          showAllSymbol: true,
          symbolSize: 0,
          smooth: true,
          itemStyle: {
          normal: {
            color: `#FFDF04`,
            lineStyle: {
            //线的颜色
            color: `#07D790`,
            width: 1.5,
            },
            areaStyle: {
            //新版渐变色实现
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
              {
                offset: 0,
                color: "rgba(255, 223, 4, 0.2)",
              },
              {
                offset: 1,
                color: "rgba(255, 223, 4, 0.1)",
              },
              ],
            },
            },
          },
          },
          data: seriesData1,
        }
        ],
      };

      window.addEventListener("resize", function () {
        myChartqx.resize();
      });
      // 动态显示tootip
      // var faultByHourIndex1 = 0; //播放所在下标
      // setInterval(function () {
      // 	//使得tootip每隔三秒自动显示
      // 	myChartqx.dispatchAction({
      // 	type: "showTip", // 根据 tooltip 的配置项显示提示框。
      // 	seriesIndex: 0,
      // 	dataIndex: faultByHourIndex1,
      // 	});
      // 	faultByHourIndex1++;
      // 	if (faultByHourIndex1 >= option.series[0].data.length) {
      // 	faultByHourIndex1 = 0;
      // 	}
      // }, 1500);
      option && myChartqx.setOption(option);
    },
    // 气象结束
    // 土壤开始
    trzxshow(e) {
      const lisst = e.target.closest(".tcgd2"); // 定位元素
      if (lisst) { // 是否是滚动组件的某一行/列
        let itemlist  = lisst.dataset.item
        let value = JSON.parse(itemlist)
        this.deployId = value.deployId
        this.itemValue = value.item
        this.summrayMode = 'dayhours'
        this.deviceSummaryApi()
      }
      this.lodshow = true	
      setTimeout(() => {
        this.echrtTrCkick()
      }, 1500);
      setTimeout(() => {
        this.lodshow = false	
      }, 2000);
    },
    echrtTrCkick(){
        // 基于准备好的dom，初始化echarts实例
        
          if (myChart != null && myChart != "" && myChart != undefined) {
            //  已存在则调用 dispose() 方法销毁
            myChart.dispose();
          }
          var myChart = echarts.init(this.$refs.columnTrEchart);
        // 绘制图表
        let legendData = this.descriptionValue;
        let xAxisData = this.timeListVlaue;
        let seriesData1 = this.dataListVlaue;
        let option;
        option = {
          tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(13, 64, 71, 0.50)",
          borderColor: "rgba(143, 225, 252, 0.60)",
          padding: 8,
          textStyle: {
            color: "#fff",
          },
          },
          grid: {
          left: "1%",
          right: "1%",
          top: "14%",
          bottom: "2%",
          containLabel: true,
          },
          legend: {
          icon: "rect",
          top: "1%",
          itemWidth: 7, // 设置宽度
          itemHeight: 7, // 设置高度
          itemGap: 15, // 设置间距
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
          },
          xAxis: {
          boundaryGap: true,
          data: xAxisData,
          axisLine: {
            lineStyle: {
            color: "rgba(117, 168, 202, 0.4)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
          },
          },
          yAxis: [
          {
            name: this.unitValue,
            type: "value",
            inverse: false,
            splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(117, 168, 202, 0.3)",
              type: "dashed",
            },
            },
            axisLine: {
            show: false,
            lineStyle: {
              color: "#0A5C95",
            },
            },
            axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: "#89BFE5",
              fontSize: 12,
            },
            },
            nameTextStyle: {
            color: "#89BFE5",
            padding: [0, 0, 0, 15],
            fontSize: 12,
            },
            axisTick: {
            show: false,
            },
          },
          ],
          series: [
          {
            name: legendData,
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
            normal: {
              color: `#FFDF04`,
              lineStyle: {
              //线的颜色
              color: `#07D790`,
              width: 1.5,
              },
              areaStyle: {
              //新版渐变色实现
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                {
                  offset: 0,
                  color: "rgba(255, 223, 4, 0.2)",
                },
                {
                  offset: 1,
                  color: "rgba(255, 223, 4, 0.1)",
                },
                ],
              },
              },
            },
            },
            data: seriesData1,
          }
          ],
        };

        window.addEventListener("resize", function () {
          myChart.resize();
        });
        // 动态显示tootip
        // var faultByHourIndex = 0; //播放所在下标
        // setInterval(function () {
        //   //使得tootip每隔三秒自动显示
        //   myChart.dispatchAction({
        //   type: "showTip", // 根据 tooltip 的配置项显示提示框。
        //   seriesIndex: 0,
        //   dataIndex: faultByHourIndex,
        //   });
        //   faultByHourIndex++;
        //   if (faultByHourIndex >= option.series[0].data.length) {
        //   faultByHourIndex = 0;
        //   }
        // }, 1500);
        option && myChart.setOption(option);
      }
    // 土壤结束
  },
  beforeDestroy() {
    // if (this.player) {
    //   this.player.destroy();
    // }
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "@/assets/css/home.css";
.listTit{
    width: 100%;
    height: 63px;
    line-height: 63px;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    font-weight: bold;
    background: url(@/assets/images/listtit.png)no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
    text-shadow: 0px 0px 8px #00FFC2;
    display: block;
    position: relative;
    cursor: pointer;
    &::after {
        content: '';
        position: absolute;
        top: 1px;
        left: 0px;
        width:4px;
        height: 40px;
        background: rgba(41,255,206,1);
        border-radius: 100%;
        animation: flow 5s ease infinite ; 
        filter: blur(6px); 
      }
}
.yqgkcCon{
  height: 590px;
  overflow: hidden;
  position: relative;
  .jiakMore{
    width: 140px;
    height: 40px;
    line-height: 40px;
    border-radius: 40px;
    background: #00a169;
    margin: 0 auto;
    margin-top: 14px;
    color: #fff;
    cursor: pointer;
  }
  .wlshebei{
    width: 94%;
    height: 94px;
    border-radius: 74px;
    background: rgba(0, 73, 65, .4);
    margin: 0 auto;
    margin-top: 20px;
    overflow: hidden;
    .wlshebeiNei{
      width: 96%;
      height: 86px;
      border: 1px dashed rgba(51, 254, 255, .4);
      border-radius: 66px;
      margin: 0 auto;
      margin-top: 3px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content:space-between;
      .wlshebeiNei_goge{
        width: 25%;
        height: 100%;
        .num{
          font-size: 30px;
          color: #01E393;
          font-family:"UnidreamLED" ;
          display: block;
          text-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
          margin-top: 14px;
        }
        .name{
          font-size: 14px;
          color:#16E3B1 ;
        }
        .num2{
          font-size: 30px;
          color: #39B7FF;
          font-family:"UnidreamLED" ;
          display: block;
          text-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
          margin-top: 14px;
        }
        .name2{
          font-size: 14px;
          color:#39B6FE ;
        }
        .num3{
          font-size: 30px;
          color: #ECA825;
          font-family:"UnidreamLED" ;
          display: block;
          text-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
          margin-top: 14px;
        }
        .name3{
          font-size: 14px;
          color:#ECA826 ;
        }
        .num4{
          font-size: 30px;
          color: #25dfec;
          font-family:"UnidreamLED" ;
          display: block;
          text-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
          margin-top: 14px;
        }
        .name4{
          font-size: 14px;
          color:#25dfec ;
        }
      }
    }
  }
  .sbzhuan{
    width: 112px;
    height: 112px;
    border-radius: 112px;
    background: url(@/assets/images/jyzt/sbzhuan.png) no-repeat 100% 100%;
    background-size: cover;
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 2;
    .sbzhuan_num{
      color: #fff;
      font-size: 12px;
      display: block;
      width: 60%;
      margin: 0 auto;
      margin-top: 24px;
      span{
        color: #01E393;
        font-size: 30px;
        font-family:"UnidreamLED";
      }
    }
  }
  .yiqiList{
    width:100%;
    height: 290px;
    margin: 10px 0px;
    overflow: hidden;
    .qyListCov{
      width: 195px;
      height: 80px;
      background: url(@/assets/images/jcsjiconbak.png)no-repeat 100% 100%;
      background-size: cover;
      overflow: hidden;
      display: inline-block;
      margin-bottom: 10px;
      margin-left: 15px;
      cursor: pointer;
      float: left;
      .qyicon{
        width: 60px;
        height: 48px;
        float: left;
        margin-top: 20px;
        margin-left: 3%;
      }
      .qyrit{
        width: 60%;
        float: right;
        text-align: left;
        .qyritName{
          font-size: 14px;
          color: #fff;
          display: block;
          margin-top: 16px;
        }
        .qiritdanw{
          font-size: 26px;
          color: #63FFEC;
          font-family:"UnidreamLED";
          span{
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
    .qyListCov:hover{
      transform: scale(1.03);
    }
  }
   /* 定义滚动条样式 */
  .yiqiList::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: rgba(240, 240, 240, 0.1);
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .yiqiList::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, 0);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, 0);
  }
  /*定义滑块 内阴影+圆角*/
  .yiqiList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px rgba(36, 132, 109, 0.8);
    background-color: rgba(36, 132, 109, 0.8);
  }
  video{ 
		width: 450px;
		object-fit: fill;
	}
	video::-webkit-media-controls {
		width: 450px;
	}
}
.wlsecov{
  .jklistchanye {
    width: 100%;
    height: 42vw;
    /* background: url(../../assets/images/tccovbak.png) no-repeat;
      background-size: 100% 100%; */
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339d94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14, 252, 255, 0.8);
    position: relative;
    overflow: hidden;
    z-index: 9;
    .guanbiann {
      width: 28px;
      height: 28px;
      position: absolute;
      right: 2%;
      top: 0.5vw;
      z-index: 9999999999;
      cursor: pointer;
    }
    .tz_cov_topchanye {
      width: 100%;
      height: 48px;
      background: url(@/assets/images/tctopback.png) no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 48px;
      margin-bottom: 20px;
    }
    .jkListPl{
      width: 100%;
      height: 880px;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      overflow: auto;
      padding-bottom: 10px;
      align-content: flex-start;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: wrap;
      .jkOver{
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 1;
        width: 94px;
        height: 94px;
        background: url(@/assets/images/jko1backgroundbutton.png)no-repeat;
        overflow: hidden;
        .jko1guang{
          width: 92px;
          height: 92px;
          animation: fadeInLeft 2s linear infinite;
          cursor: pointer;;
        }
         @keyframes fadeInLeft {
          from {
              transform: rotate(360deg);
          }
          to {
              transform: rotate(0deg);
          }
      }
      }
    }
    /* 定义滚动条样式 */
    .jkListPl::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      background-color: rgba(240, 240, 240, 0.1);
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .jkListPl::-webkit-scrollbar-track {
      box-shadow: inset 0 0 0px rgba(240, 240, 240, 0);
      border-radius: 10px;
      background-color: rgba(240, 240, 240, 0);
    }
    /*jkListPl 内阴影+圆角*/
    .styjCon::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 0px rgba(36, 132, 109, 0.8);
      background-color: rgba(36, 132, 109, 0.8);
    }
  }
  /* // 右侧文本样式 */
  ::v-deep .el-timeline-item__content {
    margin-left: 6%;
    width: 90%;
    /* height: 50px; */
    // padding-top: 5px;
  }
  /* // 时间样式 */
  .el-timeline-item__wrapper{
    top: 0px !important;
  }
  ::v-deep .el-timeline-item__timestamp.is-bottom {
    position: absolute;
    top: 0;
    left: 10%;
  }
  ::v-deep .el-timeline-item__timestamp {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #fff;
    text-align: left;
    width: 88.4%;
    height: 28px;
    line-height: 28px;
    margin-left: 5%;
    padding-left: 3%;
    background: url(@/assets/images/jyzt/titleBg.png)  0 0 / 100% 100%;
  }
  ::v-deep .el-timeline-item__timestamp.is-top{
    margin-bottom: 0px !important;
  }
  /* // 竖线样式 */
  ::v-deep .el-timeline-item__tail {
    position: absolute;
    top: 10px;
    left: 5%;
    height: 100%;
    width: 2px;
    opacity: 0.2;
    border-left: solid 3px #00fbbe;
  }
  /* // 圆点样式 */
  ::v-deep .el-timeline-item__node--normal {
    left: 1%;
    width: 40px;
    height: 40px;
    background: url(@/assets/images/jyzt/nongshi.png) no-repeat 100% 100%;
    background-size: 28px 28px;
    background-position: 5px 5px;
  }
  .tz_cov_zaip{
    width: 100%;
    height: 1000px;
    /* background: url(../../assets/images/tccovbak.png) no-repeat;
      background-size: 100% 100%; */
      background: rgba(15,36,69,0.7);
      border-radius: 0.5vw;
      border: 1px solid #339D94;
      text-align: center;
      overflow: hidden;
      box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
    position: relative;
  }
  .tz_cov_zaip .el-tabs--border-card{
      background: none;
      border: none;
      box-shadow: none;
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__header{
      background: none;
      border: none;
      box-shadow: none;
      margin-left: 15px;
      /* padding-left: 15px; */
  }
  .tz_cov_zaip .el-tabs__item{
      background: #0F5474;
      border: 1px solid #0089AE!important;
      margin-right: 1%!important;
      color: #C9C9C9!important;
      font-size: 16px;
      padding: 0px 15px!important;
      box-sizing: border-box;
      /* height: 40px !important; */
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
      background: #0089AE;
      border: 1px solid #1A848F!important;
      margin-right: 1%!important;
      color: #fff!important;
      font-size: 16px;
      padding: 0 8px;
      box-sizing: border-box;
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__content{
  padding: 0;
  margin-top: 20px;
  }
  .tz_cov_top_tit {
      font-size: 20px;
      font-family: douyuFont;
      color: #fff;
      text-align: center;
    }
    .tczpms_list{
        width: 24%;
        background: rgba(35, 168, 151, 0.2);
        border-radius: 8px;
        border: 1px solid #23a897;
        margin-bottom: 10px;
        margin-left: 0.7%;
        height: 288px; 
    }
    .tczpms_list_top{
        width: 100%;
        height: 30px;
        line-height: 30px;
        background: rgba(35, 168, 151, 0.4);
        border-radius: 8px 8px 0px 0px;
    }
    .tczpms_list_top_lf{
        font-size: 16px;
        color: #fff;
        margin-left: 3%;
        float: left;
    }
    .jczimg{
      width: 100%;
      height: 253px;
    }
    .guanbiann {
      width: 28px;
      height: 28px;
      position: absolute;
      right: 2%;
      top: 0.5vw;
      z-index: 9999999999;
      cursor: pointer;
    }
    .tz_cov_topchanye {
      width: 100%;
      height: 48px;
      background: url(@/assets/images/tctopback.png) no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 48px;
      margin-bottom: 20px;
    }
}
.jkczCov{
 width: 19%;
 float: right;
 .jkczCov_sxzy{
  width: 157px;
  height: 163px;
  background: url(@/assets/images/jkoperate.png) no-repeat;
  background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
  margin: 0 auto;
  margin-top: 200px;
  position: relative;
  cursor: pointer;
  .jkczCov_Topsxzy{
    width: 17px;
    height: 23px;
    position: absolute;
    top: 16px;
    left: 70px;
    z-index: 1;
    transition: transform 0.1s ease;
    font-size: 20px;
  }
  .jkczCov_Btmsxzy{
    width: 17px;
    height: 23px;
    position: absolute;
    bottom: 24px;
    left: 70px;
    z-index: 1;
    transition: transform 0.1s ease;
    font-size: 20px;
  }
  .jkczCov_Lfsxzy{
    width: 17px;
    height: 23px;
    position: absolute;
    bottom: 75px;
    left: 20px;
    z-index: 1;
    transition: transform 0.1s ease;
    font-size: 20px;
  }
  .jkczCov_Rtsxzy{
    width: 17px;
    height: 23px;
    position: absolute;
    bottom: 75px;
    right: 20px;
    z-index: 1;
    transition: transform 0.1s ease;
    font-size: 20px;
  }
  .jkczCov_Topsxzy:active {
    transform: translateY(2px);
  }
  .jkczCov_Btmsxzy:active {
    transform: translateY(2px);
  }
  .jkczCov_Lfsxzy:active {
    transform: translateY(2px);
  }
  .jkczCov_Rtsxzy:active {
    transform: translateY(2px);
  }
 }
 .jkczCov_daxiao{
  width: 200px;
  height: 52px;
  margin: 0 auto;
  margin-top: 50px;
  overflow: hidden;
  .daxiaoLf{
    width: 50px;
    height: 50px;
    float: left;
    cursor: pointer;
    transition: transform 0.1s ease;
  }
  .daxiaoRt{
    width: 50px;
    height: 50px;
    float: right;
    cursor: pointer;
    transition: transform 0.1s ease;
  }
 }
}
.daxiaoLf:active {
  transform: translateY(2px);
}
.daxiaoRt:active {
  transform: translateY(2px);
}

.el-pagination,.el-pagination__total,.el-pagination__jump,.el-pager li.btn-quicknext,.el-select-dropdown__item{
	    color: #fff !important;
	}
	.el-pagination .btn-next, .el-pagination .btn-prev{
	    background: center center no-repeat rgba(0,0,0,.3) !important;
	    color: #fff !important;
	}
	.el-pager li{
	    background: rgba(0, 77, 29, 0.9) !important;
	}
	.el-input__inner{
	    color: #fff !important;
	    border: 1px solid #00943e !important;
	    background-color:  rgba(0,0,0,.3) !important
	}
	.el-select-dropdown{
	    border: 1px solid #00943e !important;
	    background:  rgba(0,0,0,.3) !important
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
	    background:  #009b3b !important
	}
  // 土壤开始
.tztr_cov_chanye{
  width: 100%;
	height: 670px;
  background: rgb(1 26 12 / 70%);
  border-radius: 10px;
  border: 1px solid #339D94;
  text-align: center;
  overflow: hidden;
  box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
	position: relative;
	overflow: hidden;
  .guanbiann{
	width: 28px;
	height: 28px;
	position: absolute;
	right: 2%;
	top: 10px;
	z-index: 9999999999;
	cursor: pointer;
}
.tz_cov_topchanye{
	width: 100%;
	height:48px;
	background: url(@/assets/images/tctopback.png)no-repeat ;
	background-size: 100% 100%;
	text-align: center;
	line-height: 48px;
	margin-bottom: 20px;
}
.tz_cov_top_tit{
	font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    text-align: center;
}
.tcgldw{
	font-size: 18px;
    color: #fff;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 38px;
    text-align: left;
    text-indent: 2em;
    height: 576px;
    overflow: auto;
    /* text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 15; */
}
/* 定义滚动条样式 */
.tcgldw::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}

.ycboxlt{
    width: 94%; margin-left: 2%;
    background: url(@/assets/images/tckuang.png)no-repeat ;
	background-size: 100% 100%;
    padding: 10px;
}
.ycboxlt4{
    width: 94%; margin-left: 2%;
	background-size: 100% 100%;
    padding: 10px;
}
.tz_cov_topyqjs{
    width: 100%;
	  height:600px;
}
.tz_cov_top{
    width: 100%;
	  height:600px;
    overflow: auto;
    animation: fadeInLeft 1s 0.02s ease backwards;
}

// 弹出结束
.qxsjssjc{
	width: 100%;
	height: 366px;
	overflow: hidden;
}
.qxsjssjc_left{
	width: 12%;
  height: 500px;
	overflow: auto;
  z-index: 3;
  position: absolute;
  left: 10px;
  top: 20px;
}
/* 定义滚动条样式 */
.qxsjssjc_left::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.qxsjssjc_left::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.qxsjssjc_left::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.qxsjssjc_right{
	width: 12%;
  height: 500px;
  overflow: auto;
  z-index: 3;
  position: absolute;
  left: 370px;
  top: 20px;
}
/* 定义滚动条样式 */
.qxsjssjc_right::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.qxsjssjc_right::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.qxsjssjc_right::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.qxjcimg2{
	width: 50%;
	height: 326px;
	float: left;
}
.qxsjssjc_left_list{
	width: 106px;
	height: 58px;
	background: url(@/assets/images/qxbg.png)no-repeat;
  background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
	// border: 1px solid #01E393;
	border-radius: 6px;
	margin-left: 3%;
	text-align: center;
	margin-top: 28px;
	cursor: pointer;
}
.qxsjssjc_left_list:hover{
  transform: scale(1.04);
}
.qxsjssjc_left_list_tit{
	width: 100%;
	height: 20px;
	text-align: center;
	line-height: 20px;
	// background-image: linear-gradient(rgba(1, 227, 147, 0.1), rgba(1, 227, 147, 0.1));
	color: #fff;
	font-size: 14px;
	border-radius: 6px 6px 0 0;
	margin-top: 4px;
}
.qxsjssjc_left_list_show{
	font-size: 16px;
	color: #01E393;
	display: inline-block;
	padding-top: 12px;
}
.qxsjssjcTc{
	width: 100%;
	height: 580px;
	overflow: hidden;
}
.tcyqimg{
    width:226px;
    height: 410px;
    position: absolute;
    left:11%;
    bottom: 100px;
	  z-index: 2;
}
.tcdzimg{
    width: 40%;
    margin-left: 5%;
    position: absolute;
    left: -5%;
    bottom: 10px;
	z-index: 1;
}
.tcxitit{
	display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
}

.bianqianlist{
	width: 100%;
	height: 40px;
	overflow: hidden;
	margin-top: 10px;
	.xiaoshi{
		width: 48px;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
		border: 1px solid #D6D6D6;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
	}
	.xiaoshiHover{
		width: 48px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background: #04A66F;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
    cursor: pointer;
		// border: 1px solid #D6D6D6;
	}
	.zsfsList{
		float: right;
		color: #fff;
		font-size: 14px;
		margin-right: 20px;
	}
}
.jcsjtclist{
    width: 138px;
    height: 60px;
    background: url(@/assets/images/trbg.png)no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
    border-radius: 6px;
    margin-top: 14px;
    cursor: pointer;
    .jcsjicon1{
        width: 46px;
        margin-top: 14px;
    }
    .jcsjicon1_tit{
        font-size: 14px;
        color: #fff;
        display: block;
        margin-top: 14px;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .jcsjicon1_num{
        color: #63ffec;
        font-size: 18px;
        font-family: "UnidreamLED";
        text-align: left;
        display: block;
    }
    .jcsjicon1_dan{
        font-size: 14px;
        color: #fff;
        margin-left: 3%;
    }
  }
.jcsjtclist:hover{
  transform: scale(1.04);
}
}
// 土壤结束
// 气象开始
:deep .el-dialog {
    position: relative;
    margin: 0 auto;
    background: none;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
    /* margin-left: 22%; */
}
:deep .el-dialog__header{
	display: none;
}
.tzqx_cov_chanye{
	width: 100%;
	height: 42vw;
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
    position: relative;
    overflow: hidden;
  .qxsjssjc{
	width: 100%;
	height: 366px;
	overflow: hidden;
}
.qxsjssjc_left{
	width: 25%;
	float: left;
}
.qxsjssjc_leftTc{
	width: 10%;
	position: absolute;
	left: 2%;
	top: 40px;
	z-index: 33;
}
.qxsjssjc_leftTc2{
	width: 10%;
	position: absolute;
	left: 30%;
	top: 40px;
	z-index: 33;
}
.qxjcimg2{
	width: 50%;
	height: 326px;
	float: left;
}
.qxsjssjc_left_list{
	width: 106px;
	height: 58px;
	background: url(@/assets/images/qxbg.png)no-repeat;
  background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
	// border: 1px solid #01E393;
	border-radius: 6px;
	margin-left: 3%;
	text-align: center;
	margin-top: 28px;
	cursor: pointer;
}
.qxsjssjc_left_list:hover{
  transform: scale(1.04);
}
.qxsjssjc_left_list_tit{
	width: 100%;
	height: 20px;
	text-align: center;
	line-height: 20px;
	// background-image: linear-gradient(rgba(1, 227, 147, 0.1), rgba(1, 227, 147, 0.1));
	color: #fff;
	font-size: 14px;
	border-radius: 6px 6px 0 0;
	margin-top: 4px;
}
.qxsjssjc_left_list_show{
	font-size: 16px;
	color: #01E393;
	display: inline-block;
	padding-top: 12px;
}
.qxsjssjcTc{
	width: 100%;
	height: 580px;
	overflow: hidden;
}
.tcyqimg{
    width:14%;
    position: absolute;
    left: 14%;
    bottom: 108px;
	z-index: 2;
}
.tcdzimg{
    width: 40%;
    margin-left: 5%;
    position: absolute;
    left: -4%;
    bottom: 20px;
	z-index: 0;
}
.tcxitit{
	display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
}
// 弹出开始
:deep .el-dialog {
    position: relative;
    margin: 0 auto;
    background: none;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
    /* margin-left: 22%; */
}
:deep .el-dialog__header{
	display: none;
}
.tz_cov_chanye{
	width: 100%;
	height: 42vw;
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
	position: relative;
	overflow: hidden;
}
.guanbiann{
	width: 28px;
	height: 28px;
	position: absolute;
	right: 2%;
	top: 0.5vw;
	z-index: 9999999999;
	cursor: pointer;
}
.tz_cov_topchanye{
	width: 100%;
	height:48px;
	background: url(@/assets/images/tctopback.png)no-repeat ;
	background-size: 100% 100%;
	text-align: center;
	line-height: 48px;
	margin-bottom: 20px;
}
.tz_cov_top_tit{
	font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    text-align: center;
}
.tcgldw{
	font-size: 18px;
    color: #fff;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 38px;
    text-align: left;
    text-indent: 2em;
    height: 576px;
    overflow: auto;
    /* text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 15; */
}
/* 定义滚动条样式 */
.tcgldw::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}

.ycboxlt{
    width: 94%; margin-left: 2%;
    background: url(@/assets/images/tckuang.png)no-repeat ;
	background-size: 100% 100%;
    padding: 10px;
}
.ycboxlt4{
    width: 94%; margin-left: 2%;
	background-size: 100% 100%;
    padding: 10px;
}
.tz_cov_topyqjs{
    width: 100%;
	  height:600px;
}
.tz_cov_top{
    width: 100%;
	  height:600px;
    overflow: auto;
    animation: fadeInLeft 1s 0.02s ease backwards;
}
.in1con_lf_imglf_num_jix {
	color: #63ffec;
    font-size: 16px;
    font-family: "UnidreamLED";
}

// 弹出结束

.bianqianlist{
	width: 100%;
	height: 40px;
	overflow: hidden;
	margin-top: 10px;
	.xiaoshi{
		width: 48px;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
		border: 1px solid #D6D6D6;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
	}
	.xiaoshiHover{
		width: 48px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background: #04A66F;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
		// border: 1px solid #D6D6D6;
	}
	.zsfsList{
		float: right;
		color: #fff;
		font-size: 14px;
		margin-right: 20px;
	}
}
}
//气象结束
</style>

